export default __webpack_public_path__ + "static/media/werender-io.d36ec49c.jpg";